var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "main" },
    [
      _c(
        "b-tabs",
        [
          _c(
            "b-tab",
            { attrs: { title: "Leaves", active: "" } },
            [
              _c(
                "b-card",
                [
                  _c(
                    "b-card-body",
                    [
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            {
                              staticClass: "d-flex justify-content-end",
                              attrs: { md: "12" },
                            },
                            [
                              _c(
                                "b-modal",
                                {
                                  ref: "addNewLeaveRequest",
                                  attrs: {
                                    id: "modal-add-leave-request",
                                    "ok-only": "",
                                    "ok-title": "Add",
                                    centered: "",
                                    size: "lg",
                                    title: "New Leave Request",
                                    "hide-footer": true,
                                  },
                                },
                                [
                                  _c("NewLeaveRequest", {
                                    attrs: {
                                      employeeId: _vm.selectedEmployeeId,
                                    },
                                    on: {
                                      LeaveRequestAdded: _vm.closeAddModal,
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "b-button",
                                {
                                  directives: [
                                    {
                                      name: "b-modal",
                                      rawName:
                                        "v-b-modal.modal-add-leave-request",
                                      modifiers: {
                                        "modal-add-leave-request": true,
                                      },
                                    },
                                  ],
                                  attrs: { variant: "primary" },
                                },
                                [
                                  _c("feather-icon", {
                                    staticClass: "mr-50",
                                    attrs: { icon: "PlusIcon" },
                                  }),
                                  _vm._v(" New Leave Request "),
                                ],
                                1
                              ),
                              _c(
                                "b-button",
                                {
                                  staticClass: "ml-2",
                                  attrs: { variant: "outline-primary" },
                                  on: { click: _vm.exportToExcel },
                                },
                                [
                                  _c("feather-icon", {
                                    staticClass: "mr-50",
                                    attrs: { icon: "DownloadIcon" },
                                  }),
                                  _vm._v(" Export to Excel "),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            {
                              staticClass: "my-1",
                              attrs: { cols: "12", md: "2", sm: "1" },
                            },
                            [
                              _c(
                                "b-form-group",
                                { staticClass: "mb-0" },
                                [
                                  _c(
                                    "label",
                                    {
                                      staticClass:
                                        "d-inline-block text-sm-left",
                                    },
                                    [_vm._v("Per page")]
                                  ),
                                  _c("b-form-select", {
                                    attrs: {
                                      id: "perPageSelect",
                                      size: "sm",
                                      options: _vm.pageOptions,
                                    },
                                    model: {
                                      value: _vm.perPage,
                                      callback: function ($$v) {
                                        _vm.perPage = $$v
                                      },
                                      expression: "perPage",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            {
                              staticClass: "my-1",
                              attrs: { cols: "12", md: "4", sm: "4" },
                            },
                            [
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    label: "Filter",
                                    "label-size": "sm",
                                    "label-for": "filterInput",
                                  },
                                },
                                [
                                  _c(
                                    "b-input-group",
                                    { attrs: { size: "sm" } },
                                    [
                                      _c("b-form-input", {
                                        attrs: {
                                          id: "filterInput",
                                          type: "search",
                                          placeholder: "Type to Search",
                                        },
                                        model: {
                                          value: _vm.filter,
                                          callback: function ($$v) {
                                            _vm.filter = $$v
                                          },
                                          expression: "filter",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            { attrs: { cols: "12" } },
                            [
                              _c("b-table", {
                                attrs: {
                                  striped: "",
                                  hover: "",
                                  responsive: "",
                                  "per-page": _vm.perPage,
                                  "current-page": _vm.currentPage,
                                  items: _vm.employee_items,
                                  fields: _vm.my_fields,
                                  "sort-by": _vm.sortBy,
                                  "sort-desc": _vm.sortDesc,
                                  "sort-direction": _vm.sortDirection,
                                  filter: _vm.filter,
                                  "filter-function": _vm.customFilter,
                                },
                                on: {
                                  "update:sortBy": function ($event) {
                                    _vm.sortBy = $event
                                  },
                                  "update:sort-by": function ($event) {
                                    _vm.sortBy = $event
                                  },
                                  "update:sortDesc": function ($event) {
                                    _vm.sortDesc = $event
                                  },
                                  "update:sort-desc": function ($event) {
                                    _vm.sortDesc = $event
                                  },
                                  filtered: _vm.onFiltered,
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "cell(startDate)",
                                    fn: function (data) {
                                      return [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.formatDate(
                                                data.item.startDate
                                              )
                                            ) +
                                            " "
                                        ),
                                      ]
                                    },
                                  },
                                  {
                                    key: "cell(managerId)",
                                    fn: function (data) {
                                      return [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.getEmployee(
                                                data.item.managerId
                                              )
                                            ) +
                                            " "
                                        ),
                                      ]
                                    },
                                  },
                                  {
                                    key: "cell(approvedDate)",
                                    fn: function (data) {
                                      return [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.formatDate(
                                                data.item.approvedDate
                                              )
                                            ) +
                                            " "
                                        ),
                                      ]
                                    },
                                  },
                                  {
                                    key: "cell(leaveTypeID)",
                                    fn: function (data) {
                                      return [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.getLeaveType(
                                                data.item.leaveTypeID
                                              )
                                            ) +
                                            " "
                                        ),
                                      ]
                                    },
                                  },
                                  {
                                    key: "cell(returnDate)",
                                    fn: function (data) {
                                      return [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.formatDate(
                                                data.item.returnDate
                                              )
                                            ) +
                                            " "
                                        ),
                                      ]
                                    },
                                  },
                                  {
                                    key: "cell(status)",
                                    fn: function (data) {
                                      return [
                                        _c(
                                          "b-badge",
                                          {
                                            attrs: {
                                              variant:
                                                _vm.statusVariants[
                                                  data.item.status
                                                ],
                                            },
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(data.item.status) +
                                                " "
                                            ),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                  {
                                    key: "cell(actions)",
                                    fn: function (data) {
                                      return [
                                        _c(
                                          "b-dropdown",
                                          {
                                            staticClass: "m-1",
                                            attrs: {
                                              variant: "link",
                                              "toggle-class": "p-0",
                                              "no-caret": "",
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "button-content",
                                                  fn: function () {
                                                    return [
                                                      _c("feather-icon", {
                                                        staticClass:
                                                          "align-middle text-body",
                                                        attrs: {
                                                          icon: "MoreVerticalIcon",
                                                          size: "16",
                                                        },
                                                      }),
                                                    ]
                                                  },
                                                  proxy: true,
                                                },
                                              ],
                                              null,
                                              true
                                            ),
                                          },
                                          [
                                            _c(
                                              "b-dropdown-item",
                                              {
                                                attrs: {
                                                  disabled:
                                                    !_vm.IsAdmin() ||
                                                    data.item.status ==
                                                      "CANCELLED",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.cancelAction(
                                                      "CANCELLED",
                                                      data.item.leaveRequestId
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _c("feather-icon", {
                                                  attrs: { icon: "TrashIcon" },
                                                }),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "align-middle ml-50",
                                                  },
                                                  [_vm._v("Cancel")]
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _c(
                                "b-modal",
                                {
                                  ref: "modalMydetails",
                                  attrs: {
                                    id: "modal-edit-leaves",
                                    title: "Edit Leave Request",
                                    "hide-footer": "",
                                    centered: "",
                                    size: "lg",
                                  },
                                },
                                [
                                  _c("validation-observer", {
                                    ref: "editLeaveRequestForm",
                                    scopedSlots: _vm._u([
                                      {
                                        key: "default",
                                        fn: function (ref) {
                                          var invalid = ref.invalid
                                          var validate = ref.validate
                                          return [
                                            _c(
                                              "b-form",
                                              {
                                                on: {
                                                  submit: function ($event) {
                                                    $event.preventDefault()
                                                    return _vm.updateLeaveRequest(
                                                      $event
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _vm.IsAdmin()
                                                  ? _c(
                                                      "b-col",
                                                      { attrs: { md: "6" } },
                                                      [
                                                        _c(
                                                          "b-form-group",
                                                          {
                                                            attrs: {
                                                              label:
                                                                "Employee*",
                                                              "label-for":
                                                                "employee",
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "validation-provider",
                                                              {
                                                                attrs: {
                                                                  name: "employee",
                                                                  vid: "employee",
                                                                  rules:
                                                                    "required",
                                                                },
                                                                scopedSlots:
                                                                  _vm._u(
                                                                    [
                                                                      {
                                                                        key: "default",
                                                                        fn: function (
                                                                          ref
                                                                        ) {
                                                                          var errors =
                                                                            ref.errors
                                                                          return [
                                                                            _c(
                                                                              "b-form-select",
                                                                              {
                                                                                attrs:
                                                                                  {
                                                                                    options:
                                                                                      _vm.formattedEmployeeOptions,
                                                                                    "value-field":
                                                                                      "id",
                                                                                    "text-field":
                                                                                      "fullName",
                                                                                    state:
                                                                                      errors.length >
                                                                                      0
                                                                                        ? false
                                                                                        : null,
                                                                                    required:
                                                                                      "",
                                                                                  },
                                                                                model:
                                                                                  {
                                                                                    value:
                                                                                      _vm
                                                                                        .viewLeaves
                                                                                        .employeeId,
                                                                                    callback:
                                                                                      function (
                                                                                        $$v
                                                                                      ) {
                                                                                        _vm.$set(
                                                                                          _vm.viewLeaves,
                                                                                          "employeeId",
                                                                                          $$v
                                                                                        )
                                                                                      },
                                                                                    expression:
                                                                                      "viewLeaves.employeeId",
                                                                                  },
                                                                              }
                                                                            ),
                                                                            _c(
                                                                              "small",
                                                                              {
                                                                                staticClass:
                                                                                  "text-danger",
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  _vm._s(
                                                                                    errors[0]
                                                                                  )
                                                                                ),
                                                                              ]
                                                                            ),
                                                                          ]
                                                                        },
                                                                      },
                                                                    ],
                                                                    null,
                                                                    true
                                                                  ),
                                                              }
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e(),
                                                _c(
                                                  "b-col",
                                                  { attrs: { md: "6" } },
                                                  [
                                                    _c(
                                                      "b-form-group",
                                                      {
                                                        attrs: {
                                                          label: "Leave Type",
                                                          "label-for":
                                                            "leaveType",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "validation-provider",
                                                          {
                                                            attrs: {
                                                              name: "leaveType",
                                                              rules: "required",
                                                            },
                                                            scopedSlots: _vm._u(
                                                              [
                                                                {
                                                                  key: "default",
                                                                  fn: function (
                                                                    ref
                                                                  ) {
                                                                    var errors =
                                                                      ref.errors
                                                                    return [
                                                                      _c(
                                                                        "b-form-select",
                                                                        {
                                                                          attrs:
                                                                            {
                                                                              id: "leaveType",
                                                                              options:
                                                                                _vm.leavetypes,
                                                                              "value-field":
                                                                                "leaveTypeId",
                                                                              "text-field":
                                                                                "title",
                                                                            },
                                                                          model:
                                                                            {
                                                                              value:
                                                                                _vm
                                                                                  .viewLeaves
                                                                                  .leaveTypeID,
                                                                              callback:
                                                                                function (
                                                                                  $$v
                                                                                ) {
                                                                                  _vm.$set(
                                                                                    _vm.viewLeaves,
                                                                                    "leaveTypeID",
                                                                                    $$v
                                                                                  )
                                                                                },
                                                                              expression:
                                                                                "viewLeaves.leaveTypeID",
                                                                            },
                                                                        }
                                                                      ),
                                                                      _c(
                                                                        "small",
                                                                        {
                                                                          staticClass:
                                                                            "text-danger",
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            _vm._s(
                                                                              errors[0]
                                                                            )
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ]
                                                                  },
                                                                },
                                                              ],
                                                              null,
                                                              true
                                                            ),
                                                          }
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "b-col",
                                                  { attrs: { md: "6" } },
                                                  [
                                                    _c(
                                                      "b-form-group",
                                                      {
                                                        attrs: {
                                                          label: "Start Date",
                                                          "label-for":
                                                            "startDate",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "validation-provider",
                                                          {
                                                            attrs: {
                                                              rules: "required",
                                                              name: "startDate",
                                                              vid: "startDate",
                                                            },
                                                            scopedSlots: _vm._u(
                                                              [
                                                                {
                                                                  key: "default",
                                                                  fn: function (
                                                                    ref
                                                                  ) {
                                                                    var errors =
                                                                      ref.errors
                                                                    return [
                                                                      _c(
                                                                        "b-form-datepicker",
                                                                        {
                                                                          attrs:
                                                                            {
                                                                              id: "startDate",
                                                                              placeholder:
                                                                                "Start Date",
                                                                              state:
                                                                                errors.length >
                                                                                0
                                                                                  ? false
                                                                                  : null,
                                                                              max: _vm.today,
                                                                            },
                                                                          model:
                                                                            {
                                                                              value:
                                                                                _vm
                                                                                  .viewLeaves
                                                                                  .startDate,
                                                                              callback:
                                                                                function (
                                                                                  $$v
                                                                                ) {
                                                                                  _vm.$set(
                                                                                    _vm.viewLeaves,
                                                                                    "startDate",
                                                                                    $$v
                                                                                  )
                                                                                },
                                                                              expression:
                                                                                "viewLeaves.startDate",
                                                                            },
                                                                        }
                                                                      ),
                                                                      _c(
                                                                        "small",
                                                                        {
                                                                          staticClass:
                                                                            "text-danger",
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            _vm._s(
                                                                              errors[0]
                                                                            )
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ]
                                                                  },
                                                                },
                                                              ],
                                                              null,
                                                              true
                                                            ),
                                                          }
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "b-col",
                                                  { attrs: { md: "6" } },
                                                  [
                                                    _c(
                                                      "b-form-group",
                                                      {
                                                        attrs: {
                                                          label: "End Date",
                                                          "label-for":
                                                            "returnDate",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "validation-provider",
                                                          {
                                                            attrs: {
                                                              rules:
                                                                "required|afterStartDate:@startDate",
                                                              name: "returnDate",
                                                              vid: "returnDate",
                                                            },
                                                            scopedSlots: _vm._u(
                                                              [
                                                                {
                                                                  key: "default",
                                                                  fn: function (
                                                                    ref
                                                                  ) {
                                                                    var errors =
                                                                      ref.errors
                                                                    return [
                                                                      _c(
                                                                        "b-form-datepicker",
                                                                        {
                                                                          attrs:
                                                                            {
                                                                              id: "returnDate",
                                                                              placeholder:
                                                                                "End Date",
                                                                              state:
                                                                                errors.length >
                                                                                0
                                                                                  ? false
                                                                                  : null,
                                                                              max: _vm.today,
                                                                            },
                                                                          model:
                                                                            {
                                                                              value:
                                                                                _vm
                                                                                  .viewLeaves
                                                                                  .returnDate,
                                                                              callback:
                                                                                function (
                                                                                  $$v
                                                                                ) {
                                                                                  _vm.$set(
                                                                                    _vm.viewLeaves,
                                                                                    "returnDate",
                                                                                    $$v
                                                                                  )
                                                                                },
                                                                              expression:
                                                                                "viewLeaves.returnDate",
                                                                            },
                                                                        }
                                                                      ),
                                                                      _c(
                                                                        "small",
                                                                        {
                                                                          staticClass:
                                                                            "text-danger",
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            _vm._s(
                                                                              errors[0]
                                                                            )
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ]
                                                                  },
                                                                },
                                                              ],
                                                              null,
                                                              true
                                                            ),
                                                          }
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "b-col",
                                                  { attrs: { md: "6" } },
                                                  [
                                                    _c(
                                                      "b-form-group",
                                                      {
                                                        attrs: {
                                                          label:
                                                            "Leave Duration Type",
                                                          "label-for":
                                                            "leaveDurationType",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "validation-provider",
                                                          {
                                                            attrs: {
                                                              name: "leaveDurationType",
                                                              rules: "required",
                                                            },
                                                            scopedSlots: _vm._u(
                                                              [
                                                                {
                                                                  key: "default",
                                                                  fn: function (
                                                                    ref
                                                                  ) {
                                                                    var errors =
                                                                      ref.errors
                                                                    return [
                                                                      _c(
                                                                        "b-form-select",
                                                                        {
                                                                          attrs:
                                                                            {
                                                                              options:
                                                                                _vm.leaveDurationTypeOptions,
                                                                              required:
                                                                                "",
                                                                            },
                                                                          model:
                                                                            {
                                                                              value:
                                                                                _vm
                                                                                  .viewLeaves
                                                                                  .leaveDurationType,
                                                                              callback:
                                                                                function (
                                                                                  $$v
                                                                                ) {
                                                                                  _vm.$set(
                                                                                    _vm.viewLeaves,
                                                                                    "leaveDurationType",
                                                                                    $$v
                                                                                  )
                                                                                },
                                                                              expression:
                                                                                "viewLeaves.leaveDurationType",
                                                                            },
                                                                        }
                                                                      ),
                                                                      _c(
                                                                        "small",
                                                                        {
                                                                          staticClass:
                                                                            "text-danger",
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            _vm._s(
                                                                              errors[0]
                                                                            )
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ]
                                                                  },
                                                                },
                                                              ],
                                                              null,
                                                              true
                                                            ),
                                                          }
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "b-col",
                                                  { attrs: { md: "6" } },
                                                  [
                                                    _c(
                                                      "b-form-group",
                                                      {
                                                        attrs: {
                                                          label: "Upload File",
                                                          "label-for":
                                                            "upload_file",
                                                        },
                                                      },
                                                      [
                                                        _c("b-form-file", {
                                                          attrs: {
                                                            placeholder:
                                                              "Choose a file or drop it here...",
                                                            "drop-placeholder":
                                                              "Drop file here...",
                                                          },
                                                          model: {
                                                            value:
                                                              _vm.viewLeaves
                                                                .file,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                _vm.viewLeaves,
                                                                "file",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "viewLeaves.file",
                                                          },
                                                        }),
                                                      ],
                                                      1
                                                    ),
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "b-col",
                                                  { attrs: { md: "12" } },
                                                  [
                                                    _c(
                                                      "b-form-group",
                                                      {
                                                        attrs: {
                                                          label: "Notes",
                                                          "label-for": "notes",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "validation-provider",
                                                          {
                                                            attrs: {
                                                              name: "notes",
                                                              rules: "required",
                                                            },
                                                            scopedSlots: _vm._u(
                                                              [
                                                                {
                                                                  key: "default",
                                                                  fn: function (
                                                                    ref
                                                                  ) {
                                                                    var errors =
                                                                      ref.errors
                                                                    return [
                                                                      _c(
                                                                        "b-form-textarea",
                                                                        {
                                                                          attrs:
                                                                            {
                                                                              id: "notes",
                                                                              placeholder:
                                                                                "notes",
                                                                              rows: "1",
                                                                            },
                                                                          model:
                                                                            {
                                                                              value:
                                                                                _vm
                                                                                  .viewLeaves
                                                                                  .notes,
                                                                              callback:
                                                                                function (
                                                                                  $$v
                                                                                ) {
                                                                                  _vm.$set(
                                                                                    _vm.viewLeaves,
                                                                                    "notes",
                                                                                    $$v
                                                                                  )
                                                                                },
                                                                              expression:
                                                                                "viewLeaves.notes",
                                                                            },
                                                                        }
                                                                      ),
                                                                      _c(
                                                                        "small",
                                                                        {
                                                                          staticClass:
                                                                            "text-danger",
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            _vm._s(
                                                                              errors[0]
                                                                            )
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ]
                                                                  },
                                                                },
                                                              ],
                                                              null,
                                                              true
                                                            ),
                                                          }
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "b-col",
                                                  { attrs: { md: "6" } },
                                                  [
                                                    _c(
                                                      "b-form-group",
                                                      {
                                                        attrs: {
                                                          label:
                                                            "Approving Manager*",
                                                          "label-for":
                                                            "managerId",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "validation-provider",
                                                          {
                                                            attrs: {
                                                              name: "managerId",
                                                              vid: "managerId",
                                                              rules: "required",
                                                            },
                                                            scopedSlots: _vm._u(
                                                              [
                                                                {
                                                                  key: "default",
                                                                  fn: function (
                                                                    ref
                                                                  ) {
                                                                    var errors =
                                                                      ref.errors
                                                                    return [
                                                                      _c(
                                                                        "b-form-select",
                                                                        {
                                                                          attrs:
                                                                            {
                                                                              options:
                                                                                _vm.formattedEmployeeOptions,
                                                                              "value-field":
                                                                                "id",
                                                                              "text-field":
                                                                                "fullName",
                                                                              state:
                                                                                errors.length >
                                                                                0
                                                                                  ? false
                                                                                  : null,
                                                                              required:
                                                                                "",
                                                                            },
                                                                          model:
                                                                            {
                                                                              value:
                                                                                _vm
                                                                                  .viewLeaves
                                                                                  .managerId,
                                                                              callback:
                                                                                function (
                                                                                  $$v
                                                                                ) {
                                                                                  _vm.$set(
                                                                                    _vm.viewLeaves,
                                                                                    "managerId",
                                                                                    $$v
                                                                                  )
                                                                                },
                                                                              expression:
                                                                                "viewLeaves.managerId",
                                                                            },
                                                                        }
                                                                      ),
                                                                      _c(
                                                                        "small",
                                                                        {
                                                                          staticClass:
                                                                            "text-danger",
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            _vm._s(
                                                                              errors[0]
                                                                            )
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ]
                                                                  },
                                                                },
                                                              ],
                                                              null,
                                                              true
                                                            ),
                                                          }
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "b-col",
                                                  {
                                                    staticClass:
                                                      "d-flex justify-content-between",
                                                    attrs: { md: "12" },
                                                  },
                                                  [
                                                    _c(
                                                      "b-button",
                                                      {
                                                        attrs: {
                                                          type: "button",
                                                          variant: "primary",
                                                          disabled: invalid,
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.updateLeaveRequest()
                                                          },
                                                        },
                                                      },
                                                      [_vm._v(" Save Changes ")]
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                          ]
                                        },
                                      },
                                    ]),
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "d-flex justify-content-center mb-1",
                                },
                                [
                                  _vm.loading
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "d-flex justify-content-center mb-1",
                                        },
                                        [
                                          _c("b-spinner", {
                                            staticStyle: {
                                              width: "3rem",
                                              height: "3rem",
                                            },
                                            attrs: {
                                              variant: "success",
                                              label: "Spinning",
                                            },
                                          }),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "b-col",
                            { attrs: { cols: "12" } },
                            [
                              _c("b-pagination", {
                                staticClass: "my-0",
                                attrs: {
                                  "total-rows": _vm.totalRows,
                                  "per-page": _vm.perPage,
                                  align: "center",
                                  size: "sm",
                                },
                                model: {
                                  value: _vm.currentPage,
                                  callback: function ($$v) {
                                    _vm.currentPage = $$v
                                  },
                                  expression: "currentPage",
                                },
                              }),
                              _c("b-form-group", [
                                _vm._v(
                                  " Showing " +
                                    _vm._s(
                                      _vm.totalRows > 0
                                        ? _vm.perPage * (_vm.currentPage - 1) +
                                            1
                                        : 0
                                    ) +
                                    " to " +
                                    _vm._s(
                                      _vm.totalRows > 0
                                        ? Math.min(
                                            _vm.perPage * _vm.currentPage,
                                            _vm.totalRows
                                          )
                                        : 0
                                    ) +
                                    " of " +
                                    _vm._s(
                                      _vm.totalRows > 0 ? _vm.totalRows : 0
                                    ) +
                                    " entries "
                                ),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "b-tab",
            { attrs: { title: "Subordinate Leaves" } },
            [
              _c(
                "b-card",
                [
                  _c(
                    "b-card-body",
                    [
                      _c(
                        "b-row",
                        [
                          _c("b-col", {
                            staticClass: "d-flex justify-content-end",
                            attrs: { md: "12" },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            {
                              staticClass: "my-1",
                              attrs: { md: "2", sm: "4" },
                            },
                            [
                              _c(
                                "b-form-group",
                                { staticClass: "mb-0" },
                                [
                                  _c(
                                    "label",
                                    {
                                      staticClass:
                                        "d-inline-block text-sm-left mr-50",
                                    },
                                    [_vm._v("Per page")]
                                  ),
                                  _c("b-form-select", {
                                    staticClass: "w-50",
                                    attrs: {
                                      id: "perPageSelect",
                                      size: "sm",
                                      options: _vm.pageOptions1,
                                    },
                                    model: {
                                      value: _vm.perPage1,
                                      callback: function ($$v) {
                                        _vm.perPage1 = $$v
                                      },
                                      expression: "perPage1",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "b-col",
                            { staticClass: "my-1", attrs: { md: "6" } },
                            [
                              _c(
                                "b-form-group",
                                {
                                  staticClass: "mb-0",
                                  attrs: {
                                    label: "Filter",
                                    "label-cols-sm": "3",
                                    "label-align-sm": "right",
                                    "label-size": "sm",
                                    "label-for": "filterInput",
                                  },
                                },
                                [
                                  _c(
                                    "b-input-group",
                                    { attrs: { size: "sm" } },
                                    [
                                      _c("b-form-input", {
                                        attrs: {
                                          id: "filterInput",
                                          type: "search",
                                          placeholder: "Type to Search",
                                        },
                                        model: {
                                          value: _vm.filter,
                                          callback: function ($$v) {
                                            _vm.filter = $$v
                                          },
                                          expression: "filter",
                                        },
                                      }),
                                      _c(
                                        "b-input-group-append",
                                        [
                                          _c(
                                            "b-button",
                                            {
                                              attrs: { disabled: !_vm.filter },
                                              on: {
                                                click: function ($event) {
                                                  _vm.filter = ""
                                                },
                                              },
                                            },
                                            [_vm._v(" Clear ")]
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "b-col",
                            { attrs: { cols: "12" } },
                            [
                              _c("b-table", {
                                attrs: {
                                  striped: "",
                                  hover: "",
                                  responsive: "",
                                  "per-page": _vm.perPage1,
                                  "current-page": _vm.currentPage1,
                                  items: _vm.itemsEmp,
                                  fields: _vm.subordinates_fields,
                                  "sort-by": _vm.sortBy,
                                  "sort-desc": _vm.sortDesc,
                                  "sort-direction": _vm.sortDirection,
                                  filter: _vm.filter,
                                  "filter-function":
                                    _vm.customFilterSubordinates,
                                },
                                on: {
                                  "update:sortBy": function ($event) {
                                    _vm.sortBy = $event
                                  },
                                  "update:sort-by": function ($event) {
                                    _vm.sortBy = $event
                                  },
                                  "update:sortDesc": function ($event) {
                                    _vm.sortDesc = $event
                                  },
                                  "update:sort-desc": function ($event) {
                                    _vm.sortDesc = $event
                                  },
                                  filtered: _vm.onFiltered,
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "cell(employeeId)",
                                    fn: function (data) {
                                      return [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.getEmployee(
                                                data.item.employeeId
                                              )
                                            ) +
                                            " "
                                        ),
                                      ]
                                    },
                                  },
                                  {
                                    key: "cell(leaveTypeID)",
                                    fn: function (data) {
                                      return [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.getLeaveType(
                                                data.item.leaveTypeID
                                              )
                                            ) +
                                            " "
                                        ),
                                      ]
                                    },
                                  },
                                  {
                                    key: "cell(startDate)",
                                    fn: function (data) {
                                      return [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.formatDate(
                                                data.item.startDate
                                              )
                                            ) +
                                            " "
                                        ),
                                      ]
                                    },
                                  },
                                  {
                                    key: "cell(managerId)",
                                    fn: function (data) {
                                      return [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.getEmployee(
                                                data.item.managerId
                                              )
                                            ) +
                                            " "
                                        ),
                                      ]
                                    },
                                  },
                                  {
                                    key: "cell(returnDate)",
                                    fn: function (data) {
                                      return [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.formatDate(
                                                data.item.returnDate
                                              )
                                            ) +
                                            " "
                                        ),
                                      ]
                                    },
                                  },
                                  {
                                    key: "cell(approvedDate)",
                                    fn: function (data) {
                                      return [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.formatDate(
                                                data.item.approvedDate
                                              )
                                            ) +
                                            " "
                                        ),
                                      ]
                                    },
                                  },
                                  {
                                    key: "cell(status)",
                                    fn: function (data) {
                                      return [
                                        _c(
                                          "b-badge",
                                          {
                                            attrs: {
                                              variant:
                                                _vm.statusVariants[
                                                  data.item.status
                                                ],
                                            },
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(data.item.status) +
                                                " "
                                            ),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                  {
                                    key: "cell(actions)",
                                    fn: function (data) {
                                      return [
                                        _c(
                                          "b-dropdown",
                                          {
                                            staticClass: "m-1",
                                            attrs: {
                                              variant: "link",
                                              "toggle-class": "p-0",
                                              "no-caret": "",
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "button-content",
                                                  fn: function () {
                                                    return [
                                                      _c("feather-icon", {
                                                        staticClass:
                                                          "align-middle text-body",
                                                        attrs: {
                                                          icon: "MoreVerticalIcon",
                                                          size: "16",
                                                        },
                                                      }),
                                                    ]
                                                  },
                                                  proxy: true,
                                                },
                                              ],
                                              null,
                                              true
                                            ),
                                          },
                                          [
                                            _c(
                                              "b-dropdown-item",
                                              {
                                                attrs: {
                                                  disabled:
                                                    !_vm.IsAdmin() ||
                                                    data.item.status ==
                                                      "CANCELLED",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.cancelAction(
                                                      "CANCELLED",
                                                      data.item.leaveRequestId
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _c("feather-icon", {
                                                  attrs: { icon: "TrashIcon" },
                                                }),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "align-middle ml-50",
                                                  },
                                                  [_vm._v("Cancel")]
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                            ],
                            1
                          ),
                          _c(
                            "b-modal",
                            {
                              ref: "modalSubsdetails",
                              attrs: {
                                id: "modal-edit-subs",
                                title: "Edit Subordinate Leaves",
                                "hide-footer": "",
                                centered: "",
                                size: "lg",
                              },
                            },
                            [
                              _c("validation-observer", {
                                ref: "editLeaveRequestForm",
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (ref) {
                                      var invalid = ref.invalid
                                      var validate = ref.validate
                                      return [
                                        _c(
                                          "b-form",
                                          {
                                            on: {
                                              submit: function ($event) {
                                                $event.preventDefault()
                                                return _vm.updateLeaveRequest(
                                                  $event
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _vm.IsAdmin()
                                              ? _c(
                                                  "b-col",
                                                  { attrs: { md: "6" } },
                                                  [
                                                    _c(
                                                      "b-form-group",
                                                      {
                                                        attrs: {
                                                          label: "Employee*",
                                                          "label-for":
                                                            "employee",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "validation-provider",
                                                          {
                                                            attrs: {
                                                              name: "employee",
                                                              vid: "employeeId",
                                                              rules: "required",
                                                            },
                                                            scopedSlots: _vm._u(
                                                              [
                                                                {
                                                                  key: "default",
                                                                  fn: function (
                                                                    ref
                                                                  ) {
                                                                    var errors =
                                                                      ref.errors
                                                                    return [
                                                                      _c(
                                                                        "b-form-select",
                                                                        {
                                                                          attrs:
                                                                            {
                                                                              options:
                                                                                _vm.formattedEmployeeOptions,
                                                                              "value-field":
                                                                                "id",
                                                                              "text-field":
                                                                                "fullName",
                                                                              state:
                                                                                errors.length >
                                                                                0
                                                                                  ? false
                                                                                  : null,
                                                                              required:
                                                                                "",
                                                                            },
                                                                          model:
                                                                            {
                                                                              value:
                                                                                _vm
                                                                                  .viewSubs
                                                                                  .employeeId,
                                                                              callback:
                                                                                function (
                                                                                  $$v
                                                                                ) {
                                                                                  _vm.$set(
                                                                                    _vm.viewSubs,
                                                                                    "employeeId",
                                                                                    $$v
                                                                                  )
                                                                                },
                                                                              expression:
                                                                                "viewSubs.employeeId",
                                                                            },
                                                                        }
                                                                      ),
                                                                      _c(
                                                                        "small",
                                                                        {
                                                                          staticClass:
                                                                            "text-danger",
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            _vm._s(
                                                                              errors[0]
                                                                            )
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ]
                                                                  },
                                                                },
                                                              ],
                                                              null,
                                                              true
                                                            ),
                                                          }
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ],
                                                  1
                                                )
                                              : _vm._e(),
                                            _c(
                                              "b-col",
                                              { attrs: { md: "6" } },
                                              [
                                                _c(
                                                  "b-form-group",
                                                  {
                                                    attrs: {
                                                      label: "Leave Type",
                                                      "label-for": "leaveType",
                                                    },
                                                  },
                                                  [
                                                    _c("validation-provider", {
                                                      attrs: {
                                                        name: "leaveType",
                                                        rules: "required",
                                                      },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "default",
                                                            fn: function (ref) {
                                                              var errors =
                                                                ref.errors
                                                              return [
                                                                _c(
                                                                  "b-form-select",
                                                                  {
                                                                    attrs: {
                                                                      id: "leaveType",
                                                                      options:
                                                                        _vm.leavetypes,
                                                                      "value-field":
                                                                        "leaveTypeId",
                                                                      "text-field":
                                                                        "title",
                                                                    },
                                                                    model: {
                                                                      value:
                                                                        _vm
                                                                          .viewSubs
                                                                          .leaveTypeID,
                                                                      callback:
                                                                        function (
                                                                          $$v
                                                                        ) {
                                                                          _vm.$set(
                                                                            _vm.viewSubs,
                                                                            "leaveTypeID",
                                                                            $$v
                                                                          )
                                                                        },
                                                                      expression:
                                                                        "viewSubs.leaveTypeID",
                                                                    },
                                                                  }
                                                                ),
                                                                _c(
                                                                  "small",
                                                                  {
                                                                    staticClass:
                                                                      "text-danger",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        errors[0]
                                                                      )
                                                                    ),
                                                                  ]
                                                                ),
                                                              ]
                                                            },
                                                          },
                                                        ],
                                                        null,
                                                        true
                                                      ),
                                                    }),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "b-col",
                                              { attrs: { md: "6" } },
                                              [
                                                _c(
                                                  "b-form-group",
                                                  {
                                                    attrs: {
                                                      label: "Start Date",
                                                      "label-for": "startDate",
                                                    },
                                                  },
                                                  [
                                                    _c("validation-provider", {
                                                      attrs: {
                                                        rules: "required",
                                                        name: "startDate",
                                                        vid: "startDate",
                                                      },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "default",
                                                            fn: function (ref) {
                                                              var errors =
                                                                ref.errors
                                                              return [
                                                                _c(
                                                                  "b-form-datepicker",
                                                                  {
                                                                    attrs: {
                                                                      id: "startDate",
                                                                      placeholder:
                                                                        "Start Date",
                                                                      state:
                                                                        errors.length >
                                                                        0
                                                                          ? false
                                                                          : null,
                                                                    },
                                                                    model: {
                                                                      value:
                                                                        _vm
                                                                          .viewSubs
                                                                          .startDate,
                                                                      callback:
                                                                        function (
                                                                          $$v
                                                                        ) {
                                                                          _vm.$set(
                                                                            _vm.viewSubs,
                                                                            "startDate",
                                                                            $$v
                                                                          )
                                                                        },
                                                                      expression:
                                                                        "viewSubs.startDate",
                                                                    },
                                                                  }
                                                                ),
                                                                _c(
                                                                  "small",
                                                                  {
                                                                    staticClass:
                                                                      "text-danger",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        errors[0]
                                                                      )
                                                                    ),
                                                                  ]
                                                                ),
                                                              ]
                                                            },
                                                          },
                                                        ],
                                                        null,
                                                        true
                                                      ),
                                                    }),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "b-col",
                                              { attrs: { md: "6" } },
                                              [
                                                _c(
                                                  "b-form-group",
                                                  {
                                                    attrs: {
                                                      label: "End Date",
                                                      "label-for": "returnDate",
                                                    },
                                                  },
                                                  [
                                                    _c("validation-provider", {
                                                      attrs: {
                                                        rules: "required",
                                                        name: "returnDate",
                                                        vid: "returnDate",
                                                      },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "default",
                                                            fn: function (ref) {
                                                              var errors =
                                                                ref.errors
                                                              return [
                                                                _c(
                                                                  "b-form-datepicker",
                                                                  {
                                                                    attrs: {
                                                                      id: "returnDate",
                                                                      placeholder:
                                                                        "End Date",
                                                                      state:
                                                                        errors.length >
                                                                        0
                                                                          ? false
                                                                          : null,
                                                                    },
                                                                    model: {
                                                                      value:
                                                                        _vm
                                                                          .viewSubs
                                                                          .returnDate,
                                                                      callback:
                                                                        function (
                                                                          $$v
                                                                        ) {
                                                                          _vm.$set(
                                                                            _vm.viewSubs,
                                                                            "returnDate",
                                                                            $$v
                                                                          )
                                                                        },
                                                                      expression:
                                                                        "viewSubs.returnDate",
                                                                    },
                                                                  }
                                                                ),
                                                                _c(
                                                                  "small",
                                                                  {
                                                                    staticClass:
                                                                      "text-danger",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        errors[0]
                                                                      )
                                                                    ),
                                                                  ]
                                                                ),
                                                              ]
                                                            },
                                                          },
                                                        ],
                                                        null,
                                                        true
                                                      ),
                                                    }),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "b-col",
                                              { attrs: { md: "6" } },
                                              [
                                                _c(
                                                  "b-form-group",
                                                  {
                                                    attrs: {
                                                      label:
                                                        "Leave Duration Type",
                                                      "label-for":
                                                        "leaveDurationType",
                                                    },
                                                  },
                                                  [
                                                    _c("validation-provider", {
                                                      attrs: {
                                                        name: "leaveDurationType",
                                                        rules: "required",
                                                      },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "default",
                                                            fn: function (ref) {
                                                              var errors =
                                                                ref.errors
                                                              return [
                                                                _c(
                                                                  "b-form-select",
                                                                  {
                                                                    attrs: {
                                                                      options:
                                                                        _vm.leaveDurationTypeOptions,
                                                                      required:
                                                                        "",
                                                                    },
                                                                    model: {
                                                                      value:
                                                                        _vm
                                                                          .viewSubs
                                                                          .leaveDurationType,
                                                                      callback:
                                                                        function (
                                                                          $$v
                                                                        ) {
                                                                          _vm.$set(
                                                                            _vm.viewSubs,
                                                                            "leaveDurationType",
                                                                            $$v
                                                                          )
                                                                        },
                                                                      expression:
                                                                        "viewSubs.leaveDurationType",
                                                                    },
                                                                  }
                                                                ),
                                                                _c(
                                                                  "small",
                                                                  {
                                                                    staticClass:
                                                                      "text-danger",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        errors[0]
                                                                      )
                                                                    ),
                                                                  ]
                                                                ),
                                                              ]
                                                            },
                                                          },
                                                        ],
                                                        null,
                                                        true
                                                      ),
                                                    }),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "b-col",
                                              { attrs: { md: "6" } },
                                              [
                                                _c(
                                                  "b-form-group",
                                                  {
                                                    attrs: {
                                                      label: "Upload File",
                                                      "label-for":
                                                        "upload_file",
                                                    },
                                                  },
                                                  [
                                                    _c("b-form-file", {
                                                      attrs: {
                                                        placeholder:
                                                          "Choose a file or drop it here...",
                                                        "drop-placeholder":
                                                          "Drop file here...",
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.viewSubs.file,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.viewSubs,
                                                            "file",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "viewSubs.file",
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "b-col",
                                              { attrs: { md: "12" } },
                                              [
                                                _c(
                                                  "b-form-group",
                                                  {
                                                    attrs: {
                                                      label: "Notes",
                                                      "label-for": "notes",
                                                    },
                                                  },
                                                  [
                                                    _c("validation-provider", {
                                                      attrs: {
                                                        name: "notes",
                                                        rules: "required",
                                                      },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "default",
                                                            fn: function (ref) {
                                                              var errors =
                                                                ref.errors
                                                              return [
                                                                _c(
                                                                  "b-form-textarea",
                                                                  {
                                                                    attrs: {
                                                                      id: "notes",
                                                                      placeholder:
                                                                        "notes",
                                                                      rows: "1",
                                                                    },
                                                                    model: {
                                                                      value:
                                                                        _vm
                                                                          .viewSubs
                                                                          .notes,
                                                                      callback:
                                                                        function (
                                                                          $$v
                                                                        ) {
                                                                          _vm.$set(
                                                                            _vm.viewSubs,
                                                                            "notes",
                                                                            $$v
                                                                          )
                                                                        },
                                                                      expression:
                                                                        "viewSubs.notes",
                                                                    },
                                                                  }
                                                                ),
                                                                _c(
                                                                  "small",
                                                                  {
                                                                    staticClass:
                                                                      "text-danger",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        errors[0]
                                                                      )
                                                                    ),
                                                                  ]
                                                                ),
                                                              ]
                                                            },
                                                          },
                                                        ],
                                                        null,
                                                        true
                                                      ),
                                                    }),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "b-col",
                                              {
                                                staticClass:
                                                  "d-flex justify-content-between",
                                                attrs: { md: "12" },
                                              },
                                              [
                                                _c(
                                                  "b-button",
                                                  {
                                                    attrs: {
                                                      type: "button",
                                                      variant: "primary",
                                                      disabled: invalid,
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.updateLeaveRequest(
                                                          false
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [_vm._v(" Save Changes ")]
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                            ],
                            1
                          ),
                          _c(
                            "b-col",
                            { attrs: { cols: "12" } },
                            [
                              _c("b-pagination", {
                                staticClass: "my-0",
                                attrs: {
                                  "total-rows": _vm.totalRows1,
                                  "per-page": _vm.perPage1,
                                  align: "center",
                                  size: "sm",
                                },
                                model: {
                                  value: _vm.currentPage1,
                                  callback: function ($$v) {
                                    _vm.currentPage1 = $$v
                                  },
                                  expression: "currentPage1",
                                },
                              }),
                              _c("b-form-group", [
                                _vm._v(
                                  " Showing " +
                                    _vm._s(
                                      _vm.totalRows1 > 0
                                        ? _vm.perPage1 *
                                            (_vm.currentPage1 - 1) +
                                            1
                                        : 0
                                    ) +
                                    " to " +
                                    _vm._s(
                                      _vm.totalRows1 > 0
                                        ? Math.min(
                                            _vm.perPage1 * _vm.currentPage1,
                                            _vm.totalRows1
                                          )
                                        : 0
                                    ) +
                                    " of " +
                                    _vm._s(
                                      _vm.totalRows1 > 0 ? _vm.totalRows1 : 0
                                    ) +
                                    " entries "
                                ),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }